import {Tr} from "@/i18n/i18n";
import {EffectType} from "@/store/artifact/types";
import {ConsumableType} from "@/store/consumable/types";
import SkillUtils from "@/utils/skill-utils";

export class ConsumableUtils {


    public static getEffectText(consType: ConsumableType, effectType: EffectType, effectValue: number): string {

        if (consType == ConsumableType.PLAYER) {
            return this.getEffectTypeText(effectType) + ' +' + SkillUtils.formatMoreThanMillion(effectValue);
        }

        return this.getEffectTypeText(effectType) + ' -' + SkillUtils.formatMoreThanMillion(effectValue);
    }

    private static getEffectTypeText(et: EffectType): string | undefined {
        switch (et) {
            case EffectType.ATTACK:
                return Tr('ataka');
            case EffectType.DEFENCE:
                return Tr('zaschita');
            case EffectType.ATTACK_DEFENCE:
                return Tr('ataka.i.zaschita');
            case EffectType.HEALTH:
                return Tr('zdorove');
        }
        throw new TypeError();
    }



}